import { SupabaseClient } from "@supabase/auth-helpers-react";

export type Ticket = {
    id: number;
    contractAddress: string;
    reserveAmount: number;
    onchainMintsAmount: number;
    fiatCost: number;
    fiatCurrency: string;
    ticketGenerationAvailable: boolean;
    ticketName: string;
};

export type TicketsState = {
    tickets: Map<number, Ticket>;
    loading: boolean; 
    vaultLoading: boolean; 
    error: TicketError;
    vaultSuccessful: string;
}

export enum TicketError {
    NONE,
    LOADING_FAILED,
    VAULTING_FAILED
}

export type FetchTicketDetailsByTicketAddressParams = {
    ticketAddress: string;
}

export type VaultTicketParams = {
    supabase: SupabaseClient<any, "public", any>;
    ticketAddress: string;
    tokenId: number;
    userId: string;
}
